export const grayish: string = '#b3b3b3'
export const grayishh: string = '#878787'
export const redValidationError: string = '#f44336'
export const black: string = '#000000'
export const white: string = '#ffffff'

